import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';


function Checkout() {
    const server = process.env.NODE_ENV === 'production' ? 'https://blogcode-landing.onrender.com' : 'http://localhost:8000'
    const [loading, setLoading] = useState(false);
    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [timeoutState, setTimeoutState] = useState(false);


    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: "Checkout page" });
    }, [])

    const checkout = async () => {
        let timeout = setTimeout(() => {
            setTimeoutState(true)
        }, 2000)

        try {
            if (userName.trim().length < 1 || userEmail.trim().length < 1 || !userEmail.includes('@')) {
                throw new Error()
            }

            setLoading(true);
            const res = await fetch(server + '/checkout', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    userName,
                    userEmail
                })
            }).then(res => res.json())
            clearTimeout(timeout)
            ReactGA.event({
                action: "Checkout",
                category: "User interaction",
                label: "Checkout"
            })
            setLoading(false);

            window.open(res.url, '_blank')
            setUserEmail('')
            setUserName('')
            setTimeoutState(false)
        } catch (error) {
            setLoading(false);
            setTimeoutState(false)

            alert('Error: provide correct information')
        }
    }

    return (
        <main className='bg-[#161623]'>
            <Helmet>
                <title>BlogCode - Checkout</title>
                <meta name="description" content='Setup Blog in minutes' />
                <meta name="keywords" content="react, blog, SEO, tips, blogging, reactjs" />
                <meta name="author" content="Nimish Bandha" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <link rel="canonical" href="https://getblogcode.netlify.app" />
            </Helmet>
            <div className='h-full min-h-[calc(100vh- 60px)]'>

                {/* <Header /> */}
                <div className='flex items-center flex-col justify-center h-[calc(100vh-60px)]'>
                    <h1 className='text-gray-200 text-4xl font-semibold text-center'>Provide the details to checkout</h1>

                    <p className='text-gray-300'>Use the email address you use with Github</p>
                    <form className='bg-[#2A2A42] p-4 rounded-md mt-8'>
                        <input type="text" id="name" name="name" placeholder="Github Username" className='w-full h-8 rounded-md pl-2 bg-[#161623] text-gray-300' value={userName} onChange={(e) => setUserName(e.target.value)} required disabled={loading} />
                        <br /><br />
                        <input type="email" id="email" name="email" placeholder="Email Address" className='w-full h-8 rounded-md pl-2 bg-[#161623] text-gray-300' value={userEmail} onChange={(e) => setUserEmail(e.target.value)} disabled={loading} required />
                        <button className='bg-gray-500 h-8 rounded-md w-full mt-4 hover:bg-gray-200' onClick={(e) => checkout(e)} type='button' disabled={loading}>Checkout</button>
                    </form>
                    {loading && <div className='absolute text-gray-200 bg-black z-10 w-full h-full  bg-opacity-40 text-center flex justify-center items-center flex-col'>
                        <h1 className='text-4xl font-bold'>LOADING...</h1>
                        {timeoutState && <span>Our Servers are taking longer than expected, Please try again in 1 minute.</span>}
                    </div>}
                </div>
            </div>
        </main>
    )
}

export default Checkout